import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='ltc-insurance-faq-premium-payments-claim'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Typography
          component='h2'
          align='center'
          nextElement='typography'>
          Make Premium Payments
        </Typography>
        <Typography nextElement='typography'>
          Paying premiums keeps your long&#45;term care policy in force and ensures that you will continue to receive the protection and peace of mind you planned.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Ways to Pay Your Premiums
        </Typography>
        <Typography  nextElement='typography'>
          Northwestern Mutual, acting as a service provider for Northwestern Long Term Care Insurance Company, offers three ways to pay your long&#45;term care premiums.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Automatic withdrawal or Electronic Funds Transfer &#40;EFT&#41;
        </Typography>
        <Typography nextElement='typography'>
          Automatic withdrawal is the quickest, most convenient way to pay your premiums.
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: 'Select a savings or checking account.' },
            {
              bulletText: <>
                Log on to&nbsp;
                <Link
                  id='automatic-withdrawl-access-accounts-link'
                  variant='primaryDeemphasize'
                  linkUrl='https://login.northwesternmutual.com/login'>
                  &#34;Access Your Accounts&#34;
                </Link>, select &#34;Billing Account,&#34; and complete the Automatic EFT Payments Form.
              </>,
            },
            { bulletText: <>Mail the form to Northwestern Mutual Home Office, P.O. Box 2956, Milwaukee, WI 53201&#45;9820</> },
          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          Direct Billing
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual sends you a billing notice in the mail. If you have several policies with Northwestern Mutual, you can have them placed on one bill using a Billing&#47;Payment Account Plus.
        </Typography>
        <Typography nextElement='typography'>
          <strong>Note: </strong>
          A separate Billing&#47;Payment Account is required for variable products and annuity products.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Electronic Payment Services
        </Typography>
        <Typography nextElement='typography'>
          Not to be confused with EFT, these refer to outside electronic bill payment services such as MSMoney, Quicken or your bank. Northwestern Mutual still bills you directly, but you instruct the outside service to pay the bill. An electronic payment service arrangement is an agreement between you and the provider of the service. You are responsible for coordinating the payment amount, date and payee with the service.
        </Typography>
        <Typography nextElement='typography'>
          <strong>Tip: </strong>
          When paying through an electronic payment service, use your Billing&#47;Payment Account or policy number. If the service does not ask you to enter your first and last name separately, enter your last name first.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          When You Don&#39;t Pay Your Premiums:
        </Typography>
        <Typography nextElement='typography'>
          If your premium payments are not automatically withdrawn from your bank account, Northwestern Mutual should receive payment by the due date on your bill. If your policy lapses due to nonpayment, you have up to one year from the date to which premiums were paid to reinstate the policy.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Changing Bank Names&#47;Payment Date
        </Typography>
        <Typography nextElement='typography'>
          To change the date the premium is automatically withdrawn from your bank, or to let us know you have changed banks:
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: 'Contact your Northwestern Mutual representative' },
            {
              bulletText: <>
                Northwestern Mutual directly at&nbsp;
                <Link
                  id='change-information-premium-payments-ltc-phone-link'
                  variant='primaryDeemphasize'
                  linkUrl='tel:8003888123'>
                  1&#45;800&#45;388&#45;8123
                </Link>
                , <time dateTime='7:00-06:00'>7am</time>&#8211;<time dateTime='18:00-06:00'>6pm</time> CT, Monday &#8211; Friday
              </>,
            },
            {
              bulletText: <>
                Log on to&nbsp;
                <Link
                  id='access-account-premium-payments-link'
                  variant='primaryDeemphasize'
                  linkUrl='https://login.northwesternmutual.com/login'>
                  &#34;Access Your Accounts&#34;
                </Link>
                , select &#34;Billing Account,&#34; and complete the Automatic EFT Payments Form.
              </>,
            },
          ]}
        />
        <Typography nextElement='typography'>
          To change the payment date, you will need to provide:
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: 'Your name' },
            { bulletText: <>Your Billing&#47;Payment Account number</> },
            { bulletText: 'Your bank account number' },
            { bulletText: 'The current date of your automatic withdrawal' },
            { bulletText: 'The new date of your automatic withdrawal' },
          ]}
        />
        <Typography nextElement='typography'>
          To change the bank where payments are withdrawn:
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          disableBottomPadding
          bulletedListData={[
            { bulletText: 'Your name' },
            { bulletText: <>Your Billing&#47;Payment Account number</> },
            { bulletText: <>Your bank transit&#47;routing number</> },
            { bulletText: 'Your new bank account number' },
            { bulletText: 'The name of your new bank' },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);

